var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-wrap"},[_c('div',{staticClass:"top w"},[_c('div',{staticClass:"left"},[_c('span',[_vm._v(_vm._s(this.currentDate + ' ' + this.currentWeekday))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }